<template>
  <LandingPage
    :page="page"
    :isNotFound="isNotFound"
    :shareUrl="shareUrl"
    :taglineFallback="`At ${venue_name}`"
    loadingText="Loading..."
  />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { toRefs } from 'vue'

import LandingPage from '@/modules/guestUi/components/templates/LandingPage.vue'
import { useLandingPage } from '@/modules/guestUi/composables/useLandingPage'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'
import { buildShowRichPagePath } from '@/utils/showRichPagePath'

const props = defineProps<{ slug: string }>()
const { slug } = toRefs(props)

const checkoutStore = useCheckoutStore()
const { venue_name } = storeToRefs(useSettingStore())

const { page, isNotFound, shareUrl } = useLandingPage({
  fetchPage: () => checkoutStore.getShowRichPage(slug.value),
  buildPagePath: buildShowRichPagePath,
  pageVersion: { key: 'show_page_version', version: 'rich' },
})
</script>
